import { IotError } from "@core/domain/errors/iot.error.ts";
import i18n from "../../../../i18n";

export class WeatherNoCoordsError extends IotError {
    constructor() {
        super(i18n.t("error:weather.noCoordinatesInStation"));

        Object.setPrototypeOf(this, WeatherNoCoordsError.prototype);
    }
}
